import React from 'react';
import styles from './expanded-search.tsx.module.scss';
import { Typography } from '@/ui-kit';
import { useFilter } from '@/store/use-filter';
import { useTranslation } from 'react-i18next';

interface Props {
    className?: string
}

export const ExpandedSearch: React.FC<Props> = ({
    className
}) => {
    const filterStore = useFilter()

    const { t } = useTranslation();

    return (
        <label
            htmlFor="expandedSearchCheckbox"
            className={
                [
                    styles.expandedSearch,
                    className
                ]
                    .filter(e => e?.length)
                    .join(' ')
            }>
            <Typography
                typeColor="gray"
                fontFamily="SFProText">
                {t('browse.advanced_search')}
            </Typography>
            <input
                id="expandedSearchCheckbox"
                type="checkbox"
                className={styles.expandedSearchCheckbox}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => filterStore.setExpandedSearch(e.target.checked)}
                {
                    ...(
                        filterStore.isExpandedSearch !== null ?
                            {
                                checked: filterStore.isExpandedSearch ?? false
                            }
                        :
                            {}
                    )
                } />
        </label>
    );
};
